<template>
  <v-container style="padding: 0;">
    <v-row align="center">
      <v-col cols="6">
        <v-select
          v-model="field.hour"
          :items="hours"
          label="Hour"
          @change="$emit('input', field)"
        />
      </v-col>
      <v-col cols="6">
        <v-select
          v-model="field.minute"
          :items="minutes"
          label="Minutes"
          @change="$emit('input', field)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        hour: '00',
        minute: '00',
      }),
    },
  },
  data() {
    return {
      field: {
        hour: '00',
        minute: '00',
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.field.hour = val.hour;
        this.field.minute = val.minute;
        this.$emit('input', this.field);
      },
    },
  },
  computed: {
    hours() {
      return Array.from({length: 24}).map((_, i) => i.toString().padStart(2, '0'));
    },
    minutes() {
      return Array.from({length: 60}).map((_, i) => i.toString().padStart(2, '0'));
    },
  },
};
</script>
